import { ChangeDetectionStrategy, Component, Input } from '@angular/core'
import { TuiSkeleton } from '@taiga-ui/kit'
import { TranslatePipe } from '@ngx-translate/core'
import { PricePipe } from '@shared/pipes/price.pipe'
import { LiveTickerOrderBookInterface } from '@modules/stocks-module/live-ticker/interfaces/live-ticker-order-book.interface'
import { AnimatedNumberDirective } from '@shared/directives/animated-number/animated-number.directive'

@Component({
	selector: 'app-order-book-diagrammatic',
	templateUrl: './order-book-diagrammatic.component.html',
	styleUrl: './order-book-diagrammatic.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [TuiSkeleton, TranslatePipe, PricePipe, AnimatedNumberDirective],
})
export class OrderBookDiagrammaticComponent {
	@Input() orderBook: LiveTickerOrderBookInterface | null | undefined = null
	@Input() isLoading: boolean = false

	get totalBidAskSize(): number {
		if (!this.orderBook) return 0
		return this.orderBook?.bidSize + this.orderBook.askSize
	}

	get percentAskSize(): number {
		if (!this.totalBidAskSize) return 1
		return this.orderBook?.askSize ?? 0 / this.totalBidAskSize
	}

	get percentBidSize(): number {
		if (!this.totalBidAskSize) return 1
		return this.orderBook?.bidSize ?? 0 / this.totalBidAskSize
	}
}
